import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

export default function SubRole({
  label,
  children,
  selectedData,
  onSingleselect,
}) {
  const renderSubRoles = (items) => {
    return (
      <Menu.Items className="pl-5">
        {items.map((item, key) => {
          return (
            <div
              key={key}
              title={item.label || item.name}
              className="flex items-center gap-2 border- !my-"
            >
              {item?.sub_permissions?.length ? (
                <SubRole
                  children={item.sub_permissions}
                  label={item.label || item.name}
                  onSingleselect={onSingleselect}
                  selectedData={selectedData}
                />
              ) : (
                <div
                  className="flex w-full items-center gap-2 bg-white !py-3 !my-1.5 !px-4 rounded shadow-accordion"
                  title={item.label || item.name}
                >
                  <input
                    className="h-5 w-5 focus:ring-0 cursor-pointer form-checkbox text-primary-100 rounded-sm"
                    type={"checkbox"}
                    onChange={() => onSingleselect(item.label || item.name)}
                    checked={selectedData?.includes(item.label || item.name)}
                  />
                  <span>{item.label || item.name}</span>
                </div>
              )}
            </div>
          );
        })}
      </Menu.Items>
    );
  };
  const [expandedMenus, setExpandedMenus] = useState([]);
  const isExpanded = (menu) => {
    return expandedMenus?.includes(menu);
  };
  const toggleMenu = (label) => {
    setExpandedMenus((prev) => {
      if (prev.includes(label)) {
        // If label is already in the array, remove it
        return prev.filter((item) => item !== label);
      } else {
        // Otherwise, add it to the array
        return [...prev, label];
      }
    });
  };
  return (
    <Menu as="div" className="w-full !my-1.5">
      <div className="flex items-center gap-2 !py-1 bg-white !px-4 rounded shadow-accordion">
        <input
          className="h-5 w-5 focus:ring-0 cursor-pointer form-checkbox text-primary-100 rounded-sm"
          type={"checkbox"}
          onChange={() => onSingleselect(label)}
          checked={selectedData?.includes(label)}
        />
        {/* <Menu.Button className="flex items-center justify-between w-full border-">
          <div className="flex items-center gap-2 py-2">{label}</div>
          <FaAngleDown />
        </Menu.Button> */}
        <div
          className="flex items-center justify-between w-full cursor-pointer"
          onClick={() => toggleMenu(label)}
        >
          <div className="flex items-center gap-2 py-2">{label}</div>
          {isExpanded(label) ? <FaAngleUp /> : <FaAngleDown />}
        </div>
      </div>

      <Transition
        as={Fragment}
        show={isExpanded(label)}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <div className="my-2">
          {renderSubRoles(children, onSingleselect, selectedData)}
        </div>
      </Transition>
    </Menu>
  );
}
